<template>
<!-- 重置提交按钮 -->
  <div class="submit-result" @click.stop='submit'>
    <el-button class='submitSty' type='primary'>提交</el-button>
  </div>
</template>

<script>
export default {
  name: 'SubmitResult',
  methods: {
    submit() {
      this.$emit('submitInfo');
    }
  }
}
</script>

<style lang="scss" scoped>
@import '~@/common/scss/const.scss';
@import '~@/common/scss/mixin.scss';

.submit-result {
  margin-top: pxToRem(15);
  border-radius: 4px;
  font-size:0px;
  overflow: hidden;
  touch-action: none;
  .submitSty {
    display: block;
    background:rgba(133,191,252,1);
    width: 100%;
    height: 100%;
    font-family:PingFangSC-Semibold;
    font-weight:600;
    color:rgba(255,255,255,1);
    line-height:22px;
    font-size: 18px;
    letter-spacing: 10px;
    text-align: center;
    touch-action: none;
    &:active {
      background:rgba(133,191,252,.9);
      border-color: rgba(133,191,252,.9);
    }
  }
}
</style>



// WEBPACK FOOTER //
// src/components/SubmitResult/SubmitResult.vue